<template>
  <v-form v-bind="this.$attrs">
    <v-row class="d-flex justify-end ma-2">
      <v-col cols="12" md="3">
        <AutocompleteGrade v-model="grade" return-object label="Học phần" outlined dense hide-details clearable />
      </v-col>
      <v-col cols="12" md="3">
        <AutocompleteClass
          v-model="classes"
          clear-icon="mdi-close"
          label="Lớp"
          clearable
          flat
          outlined
          dense
          return-object
          hide-details
          @change="classChanged"
        />
      </v-col>
      <v-col cols="12" md="3">
        <AutocompleteStudent
          v-model="student"
          return-object
          label="Học viên"
          outlined
          dense
          hide-details
          clearable
          @change="studentChanged"
        />
      </v-col>
      <v-col cols="12" md="3" class="d-flex justify-end">
        <v-btn class="search-button" @click="filter" outlined> Tìm kiếm </v-btn>
      </v-col>
    </v-row>
    <div
      class="d-flex justify-end align-center mx-4 mb-4"
      :class="{ 'justify-space-between': isAdvancedSearchEnabled }"
    >
      <ExcelImport v-show="isAdvancedSearchEnabled" @onDataImported="onDataImported" />
      <div
        text
        class="text-none primary--text"
        style="cursor: pointer; user-select: none"
        @click="isAdvancedSearchEnabled = !isAdvancedSearchEnabled"
      >
        {{ isAdvancedSearchEnabled ? 'Ẩn tìm kiếm theo excel' : 'Chọn tìm kiếm theo excel' }}
      </div>
    </div>
  </v-form>
</template>

<script>
import AutocompleteStudent from '@/components/basic/input/AutocompleteStudent.vue'
import AutocompleteClass from '@/components/basic/input/AutocompleteClass'
import AutocompleteGrade from '@/components/basic/input/AutocompleteGrade.vue'
import ExcelImport from '@/modules/excel-import/index.vue'

import { mapActions, mapState } from 'vuex'
import get from 'lodash-es/get'

export default {
  data() {
    return {
      classes: null,
      student: null,
      grade: null,
      isAdvancedSearchEnabled: false,
    }
  },
  components: {
    AutocompleteStudent,
    AutocompleteClass,
    AutocompleteGrade,
    ExcelImport,
  },
  async created() {
    await this.fetchClassesData()
  },
  computed: {
    ...mapState('class', ['classesData']),
    ...mapState('students', ['students']),

    currentClassId() {
      return { currentClass: get(this.classes, 'id') }
    },
  },
  methods: {
    ...mapActions('class', ['fetchClassesData']),
    ...mapActions('students', ['searchStudents']),
    async filter() {
      const params = {
        currentClass: get(this.classes, 'id'),
        grade: get(this.grade, 'id'),
        id: get(this.student, 'id'),
      }
      await this.searchStudents(params)
    },
    async onDataImported(data = []) {
      await this.searchStudents({ code_short_in: data.map((x) => x.code) })
    },
    studentChanged(student) {
      this.classes = get(student, 'currentClass')
      this.grade = get(student, 'grade')
    },
    classChanged(classData) {
      this.grade = get(classData, 'grade')
      if (get(this.student, 'currentClass.id') !== get(classData, 'id')) this.student = null
    },
  },
}
</script>

<style scoped>
.text {
  width: 154px;
  height: 20px;

  /* Body regular */

  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  /* identical to box height, or 143% */
  /* icon, sub */

  color: #797979;
}

.text-name {
  /* Toàn trường */
  width: 290px;
  height: 24px;

  /* H4 */

  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  /* identical to box height, or 133% */
  color: #000000;
}
</style>
